import styled from 'styled-components';

export const ContainerBandeira = styled.section`
  width: 100%;
  height: 100%;
  .buttonConfirm {
    background-color: #009e0f;
  }
  .buttonCancel {
    background-color: #cf2a27;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
